import { connect } from 'react-redux'
import { KingdomPopinComponent } from './KingdomPopinComponent'
import { logout, logoutDone } from 'shared/store/kingdom/dashboard'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => ({
    ...state.userState,
    availableFeatures: state.featuresState.available
})

const mapDispatchToProps = (d: Dispatch<any>) => ({
    logout: () => d(logout()),
    logoutDone: (params: { isGlobal: boolean }) => d(logoutDone(params))
})

const KingdomPopin = connect(
    mapStateToProps,
    mapDispatchToProps
)(KingdomPopinComponent)

export { KingdomPopin }
